 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT from '@/components/html/03_Copyright'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML01_FRONTISPIECE from '@/components/html/01_Frontispiece'
 import HTML04_EPIGRAPH from '@/components/html/04_Epigraph'
 import HTML05_DEDICATION from '@/components/html/05_Dedication'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_PREFACE from '@/components/html/07_Preface'
 import HTML08_INTRODUCTION__A_BLACK_POWER_PARA from '@/components/html/08_Introduction__A_Black_Power_Para'
 import HTML09_ONE__WHAT_IS__BLACK_POWER from '@/components/html/09_one__What_Is__Black_Power'
 import HTML10_TWO__PRECURSORS_AND_PRECONDITION from '@/components/html/10_two__Precursors_and_Precondition'
 import HTML11_THREE__WHO_WERE_THE__MILITANTS from '@/components/html/11_three__Who_Were_the__Militants'
 import HTML12_FOUR__THE_IDEOLOGIES_OF_BLACK_PO from '@/components/html/12_four__The_Ideologies_of_Black_Po'
 import HTML13_FIVE__BLACK_POWER_IN_AFRO_AMERIC from '@/components/html/13_five__Black_Power_in_Afro_Americ'
 import HTML14_SIX__BLACK_POWER_AND_AMERICAN_CU from '@/components/html/14_six__Black_Power_and_American_Cu'
 import HTML15_CONCLUSION__WHATEVER_HAPPENED_TO from '@/components/html/15_Conclusion__Whatever_Happened_to'
 import HTML16_NOTES from '@/components/html/16_Notes'
 import HTML17_INDEX from '@/components/html/17_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_Preface",
 			"name" : "html/07_Preface",
 			"component" : HTML07_PREFACE
 		},
 		{
 			"path" : "/html/08_Introduction__A_Black_Power_Para",
 			"name" : "html/08_Introduction__A_Black_Power_Para",
 			"component" : HTML08_INTRODUCTION__A_BLACK_POWER_PARA
 		},
 		{
 			"path" : "/html/09_one__What_Is__Black_Power",
 			"name" : "html/09_one__What_Is__Black_Power",
 			"component" : HTML09_ONE__WHAT_IS__BLACK_POWER
 		},
 		{
 			"path" : "/html/10_two__Precursors_and_Precondition",
 			"name" : "html/10_two__Precursors_and_Precondition",
 			"component" : HTML10_TWO__PRECURSORS_AND_PRECONDITION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js